const CODEC_DECODE_KEYWORDS_REGEX =
  /\b(hevc|h\.?265|codec|decode|not supported|unsupported)\b/i;

const getErrorMessage = (error) => {
  if (!error) return "";
  if (typeof error === "string") return error;
  if (typeof error.message === "string") return error.message;
  if (typeof error.reason === "string") return error.reason;
  if (typeof error.reason?.message === "string") return error.reason.message;

  if (typeof error.toString === "function") {
    const value = error.toString();
    if (
      typeof value === "string" &&
      value.length > 0 &&
      !value.startsWith("[object ")
    ) {
      return value;
    }
  }

  return "";
};

const normalizeMediaErrorCode = (mediaErrorCode) => {
  const parsedCode = Number(mediaErrorCode);
  return Number.isFinite(parsedCode) ? parsedCode : null;
};

export const isCodecDecodePlaybackIssue = ({
  mediaErrorCode = null,
  message = "",
  mediaErrorMessage = "",
} = {}) => {
  if (mediaErrorCode === 3 || mediaErrorCode === 4) return true;

  const combinedMessage = `${mediaErrorMessage || ""} ${message || ""}`.trim();
  if (!combinedMessage) return false;
  return CODEC_DECODE_KEYWORDS_REGEX.test(combinedMessage);
};

export const normalizeChatVideoPlaybackError = ({
  origin = "unknown",
  error = null,
  mediaError = null,
  video = null,
  url = null,
  isFullScreen = false,
} = {}) => {
  const resolvedMediaError =
    mediaError ||
    video?.error ||
    error?.target?.error ||
    error?.currentTarget?.error ||
    null;

  const mediaErrorCode = normalizeMediaErrorCode(resolvedMediaError?.code);
  const mediaErrorMessage =
    typeof resolvedMediaError?.message === "string"
      ? resolvedMediaError.message
      : "";
  const errorMessage = getErrorMessage(error);
  const message = errorMessage || mediaErrorMessage || "Unknown video error";

  return {
    origin,
    message,
    errorName: typeof error?.name === "string" ? error.name : null,
    mediaErrorCode,
    mediaErrorMessage: mediaErrorMessage || null,
    currentSrc:
      (typeof video?.currentSrc === "string" && video.currentSrc) ||
      (typeof video?.src === "string" && video.src) ||
      (typeof url === "string" && url) ||
      null,
    readyState: Number.isFinite(video?.readyState) ? video.readyState : null,
    networkState: Number.isFinite(video?.networkState)
      ? video.networkState
      : null,
    url: typeof url === "string" ? url : null,
    isFullScreen: Boolean(isFullScreen),
    isCodecDecodeIssue: isCodecDecodePlaybackIssue({
      mediaErrorCode,
      message,
      mediaErrorMessage,
    }),
  };
};
